let parser;
import('parse-address').then(lib => (parser = lib));

export const parseAddressNumber = address => {
    if (!parser) return '';
    const addressParsed = parser.parseLocation(address);
    return addressParsed !== null && addressParsed.number !== null
        ? addressParsed.number
        : '';
};

export const parseAddressStreet = address => {
    if (!parser) return address;
    const addressParsed = parser.parseLocation(address);
    const addressParsedNumber =
        addressParsed !== null && addressParsed.number !== null
            ? addressParsed.number
            : '';
    return address !== undefined
        ? address
              .replace(addressParsedNumber, '')
              .replace(',', ' ')
              .trim()
        : undefined;
};



// WEBPACK FOOTER //
// ./src/utils/addressParser.js